module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-photo-8-b208e318429101ae083a43a9146ff5ba.webp";